export const storeUserQuestionarie = async (resource,data) => {
    let user;
    await resource
      .post(`api/${localStorage.getItem('perfil')}/user_questionary`,data)
      .then(
        (response) => {
          console.log(response);
          user = response.body.user;
        },
        (response) => {
          console.log(response);
        }
      );
    return user;
  }
  